module.exports = __webpack_public_path__ + "img/Logo.154c59b5.svg";